var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 14C11.3139 14 14.0002 11.3137 14.0002 8C14.0002 4.68629 11.3139 2 8.00016 2C4.68645 2 2.00016 4.68629 2.00016 8C2.00016 11.3137 4.68645 14 8.00016 14ZM15.3335 8C15.3335 12.0501 12.0503 15.3333 8.00016 15.3333C3.95008 15.3333 0.66683 12.0501 0.66683 8C0.66683 3.94991 3.95008 0.666662 8.00016 0.666662C12.0503 0.666662 15.3335 3.94991 15.3335 8Z",
    fill: "#0B907B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86225 10.4714C7.1226 10.7317 7.54471 10.7317 7.80506 10.4714L9.80506 8.47139C10.0654 8.21104 10.0654 7.78893 9.80506 7.52858L7.80506 5.52859C7.54471 5.26824 7.1226 5.26824 6.86225 5.52859C6.6019 5.78893 6.6019 6.21104 6.86225 6.47139L8.39085 7.99999L6.86225 9.52859C6.6019 9.78893 6.6019 10.211 6.86225 10.4714Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarForward);
export default __webpack_public_path__ + "static/media/calendar-forward.aca1a4a9bf3089977913e2b0ee986887.svg";
export { ForwardRef as ReactComponent };